module.exports = __webpack_public_path__ + "img/Trophy Cup Table14.03c1caf9.jpg";